export default "__VITE_ASSET__DVOpFMfq__"